var master = master || {};
( function () {
    'use strict';
    jQuery( function () {
        master.init();
    } );
    master.init = function () {
        master.utils.init();
        master.tracking.init();
        master.formElements.init();
        master.extranet.init();
        master.workshopSearch.init();
        master.ecom.init();
        master.search.init();
        master.licenseplate.init();
        master.checkout.init();
        master.dealersearch.init();
        master.serviceBooking.init();
        /* onDemand scripts - start
        master.administration.init();
        */
        master.scripts.init();
        /*onDemand scripts - end*/
        master.local.init();
    };
}() );
